import { Dialog, DialogContent, Box, Typography, CircularProgress } from "@material-ui/core";
import { useTranslation } from "react-i18next";

interface CreativeGeneratingBackgroundModalProps {
  open: boolean;
  onClose: () => void;
}

export default function CreativeGeneratingBackgroundModal({
  open,
  onClose
}: CreativeGeneratingBackgroundModalProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: 2,
          p: 1
        }
      }}
    >
      <DialogContent sx={{ textAlign: "center", py: 4 }}>
        <Box display="flex" flexDirection="column" alignItems="center">
          <CircularProgress size={40} sx={{ mb: 2, color: "primary.main" }} />

          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
            {t("creativesGenerator.backgroundGeneration.title", "יוצר קריאטיב ברקע")}
          </Typography>

          <Typography variant="body2" color="text.secondary" sx={{ mb: 2, maxWidth: 400 }}>
            {t(
              "creativesGenerator.backgroundGeneration.message",
              "הקריאטיב שלך נוצר כעת ברקע. תוכל לראות את ההתקדמות בעמוד הקריאטיבים ולהמשיך לעבוד בינתיים."
            )}
          </Typography>

          <Typography variant="caption" color="text.secondary">
            {t(
              "creativesGenerator.backgroundGeneration.duration",
              "תהליך זה אורך בדרך כלל 1-3 דקות"
            )}
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
